<template>
  <div id="addNewCashierdiary">
     <div class="addNewCashierdiary_table">
        <cashierdiary-table :isEdit="false" c_title="新增日记账" :dataRow="dataRow" ref="cashierdiaryTableRef"></cashierdiary-table>
     </div>
     <!-- 设置字段归属弹框 -->
     <choice-type ref="choiceTypeRef" @saveSuccess="saveSuccess"></choice-type>
  </div>
</template>

<script>
  import cashierdiaryTable from "./components/cashierdiaryTable/index.vue"
  import choiceType from "./components/c-query-table/choiceType.vue"
  export default {
    components:{
      cashierdiaryTable,choiceType
    },
    data() {
      return {
        dataRow:{},
        indexs:1
      }
    },
    created() {
      this.userChoice();
    },
    activated() {
      this.dataRow = {
        mark:this.indexs++
      }
    },

    methods:{
      saveSuccess() {
        this.$nextTick(()=>{
          this.$refs.cashierdiaryTableRef.getUserCustomList();
        })
      },
      // 用户更新日记账版本后第一次进来需确认字段归属
      userChoice() {
        this.$http.post('custom/getIsFillRule',{}).then(res=>{
           if(res && res.data.code == 1) {
            this.$nextTick(()=>{
              this.$refs.choiceTypeRef.dialogVisible = res.data.data;
            })
           }
        })
      },
    }
  }
</script>

<style lang='less'>
  #addNewCashierdiary {
    width: 1181px;
    margin: 55px auto 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/add-cashierdiary.vue